<template>
	<div class='pest-core-detection'>
		<!-- <div v-for='core in freqPestList'>
			<span>Выявлен очаг вредных организмов. 
		</div> -->
		<template>
			<div>
				<span v-if='freqPestList.length || freqDiseaseList.length'>Выявлено очагов: {{ freqPestList.length + freqDiseaseList.length }}. Выберите нужный:</span>
				<span v-else>Очагов не выявлено</span>
			</div>

			<table class='core-table'>
				<tr v-for='core in freqPestList'>
					<td><input
						type='radio'
						name='pest-core'
						:value='core.pest_id'
						:checked='core.pest_id === lpo.pest_core_reason_id'
						@change='onChange(core.pest_id)'
						:disabled='reasonIsSaving || !actLpoIsDraft'
					></td>
					<td>Выявлен очаг<br>вредителей.</td>
					<td>Порода:<br>{{ core.species }}.</td>
					<td>Причина повреждения: <br>{{ core.pest }}.</td>
					<!-- <td>Причина id: {{ core.pest_id }}.</td> -->
					<td>Степень заселения <br>лесного насаждения: {{ core.z_degree }}.</td>
					<td>Заселенность (зараженность), % от <br>общего запаса древесины: {{ core.z_total_freq }}.</td>
				</tr>
				<tr v-for='core in freqDiseaseList'>
					<td><input
						type='radio'
						name='pest-core'
						:value='core.disease_id'
						:checked='core.disease_id === lpo.pest_core_reason_id'
						@change='onChange(core.disease_id)'
						:disabled='reasonIsSaving || !actLpoIsDraft'
					></td>
					<td>Выявлен очаг<br>болезни.</td>
					<td>Порода:<br>{{ core.species }}.</td>
					<td>Причина повреждения: <br>{{ core.disease }}.</td>
					<!-- <td>Причина id: {{ core.disease_id }}.</td> -->
					<td>Степень заселения <br>лесного насаждения: {{ core.dmg_degree }}.</td>
					<td>Заселенность (зараженность), % от <br>общего запаса древесины: {{ core.freq }}.</td>
				</tr>
			</table>

			<div v-if='(freqPestList.length || freqDiseaseList.length) && lpo.pest_core_reason_id' class='pest-input-block'>
				<div :class='{ "not-match": !isMatch(values["pest"]) }'>
					<span class='select-title'>Вредный организм</span>
					<custom-p-select
						v-model='values.pest.value'
						:options='info_pests_transformed'
						:disabled='!actLpoIsDraft'
					/>
				</div>

				<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
					<div>
						<button @click='cancel'>Отмена</button>
						<button @click='save'>Сохранить</button>
					</div>
				</div>
			</div>
		</template>
		<!-- <button @click='test'>test</button> -->

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	const GET_PESTS = process.env.VUE_APP_ROOT_API + 'get_site_data/get_pests.php';

	export default {
		name: 'InspectionPestCoreDetection',
		data() {
			return {
				reasonIsSaving: false,

				info_pests: [],

				pest: null,
				catalogsAreLoading: false,

				values: {
					pest: {
						field: 'pest_id',
						inputType: 'select',
						value: null,
						catalog: 'info_pests_transformed'
					},

				},
			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},


			...mapState('selectedLpo',{
				lpo: state => state.lpo,
				freqDiseaseList: state => state.freqDiseaseList,
				freqPestList: state => state.freqPestList,
			}),

			...mapState({
				// info_pests: state => state.catalogs['info_pests']
			}),

			info_pests_transformed() {
				return this.info_pests.map(pest => {
					return {
						id: pest.id,
						name: pest.id + ' - ' + pest.name + ' : ' + pest.group_id
					};	
				});
			},

			lpo_pest_core_reason_id() {
				return this.lpo.pest_core_reason_id;
			},

		},
		watch: {
			lpo_pest_core_reason_id(reason_id) {
				this.getPests(reason_id);
			}
		},
		methods: {

			getPests(reason_id) {
				if (!reason_id) {
					this.info_pests = [];
				}

				const form = new FormData();
				form.append('reason_id', reason_id);

				return fetch(GET_PESTS, {
					credentials: 'include',
					method: 'post',
					body: form,
				})
				.then(res => res.json())
				.then(res => {
					this.info_pests = res;
				})
			},

			onChange(reason_id) {
				// console.log('pest_id', reason_id);

				const valueList = [
					{
						field: 'pest_core_reason_id',
						value: reason_id
					},
					{
						field: 'pest_id',
						value: null
					}
				];


				this.reasonIsSaving = true;

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				}).then(res => {
					this.resetValues();
				}).finally(() => {
					this.reasonIsSaving = false;
				});
			},

			test() {
				console.log(this.lpo);
			},

			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
					};
					valueList.push(temp);
				}

				// console.log('******');
				// console.log(JSON.stringify(valueList, null, 2));
				// return;

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},


			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						// const temp = this.info_pests_transformed.find(item => {
						// 	return item.id === this.lpo[value.field];
						// });

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						// console.log('TEMP', temp);
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'input') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			// resetRadio() {
			// 	if (this.selectedLpo.reason)
			// },

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},

		created() {
			this.getPests(this.lpo.pest_core_reason_id).then(res => {
				this.resetValues();
			});
			

			// const catalogs = [
			// 	'info_pests'
			// ];

			// this.catalogsAreLoading = true;
			// this.$store.dispatch('loadCatalogs', catalogs).then(res => {
			// 	this.catalogsAreLoading = false;
			// 	this.resetValues();
			// });
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.core-table {
		/*width: 100%;*/
	}

	.core-table tr td {
		color: orange;
		padding: 4px 20px 0 0;
		font-size: 1rem;
		font-weight: bold;
	}
	.core-table tr:hover td {
		color: darkorange;
	}


	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

	.pest-input-block {
		margin-top: 20px;
	}
	
</style>